var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.653,
    height: 44.959,
    viewBox: "0 0 226.653 44.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5",
    "data-name": "\\uADF8\\uB8F9 5",
    transform: "translate(-28.862 -119.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1",
    "data-name": "\\uADF8\\uB8F9 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M230.3,128.032l1-1.194,5.72,4.81-1,1.194-5.723-4.81Z",
    fill: "#d4d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M225.5,151.923l9.8-6.345.851,1.307-9.8,6.348-.85-1.31Z",
    fill: "#d4d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M214.664,163.389a6.982,6.982,0,1,1,9.626-2.214,7,7,0,0,1-9.626,2.214Z",
    fill: "#f0854e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M235.8,139.792a9.856,9.856,0,1,1,9.858,9.858,9.856,9.856,0,0,1-9.858-9.858Z",
    fill: "#6e9cd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M221.9,123.616a4.122,4.122,0,1,1,4.125,4.122,4.123,4.123,0,0,1-4.125-4.122Z",
    fill: "#9fca84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2",
    "data-name": "\\uADF8\\uB8F9 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M74.907,133.986,73.174,136.1a11.279,11.279,0,0,1-1.842-1.133,12.586,12.586,0,0,1-1.717-1.543,13.26,13.26,0,0,1-1.419-1.67,8.6,8.6,0,0,1-.976-1.732,8.451,8.451,0,0,1-.976,1.811,13.091,13.091,0,0,1-1.513,1.811,21.887,21.887,0,0,1-2,1.827,14.149,14.149,0,0,1-2.031,1.387l-1.953-2.08a22.261,22.261,0,0,0,3.056-2.363,12.268,12.268,0,0,0,2.267-2.835,11.157,11.157,0,0,0,1.12-2.8,13.911,13.911,0,0,0,.393-3.433v-2.207h3.276v2.427a13.867,13.867,0,0,0,.394,3.433,10.44,10.44,0,0,0,1.15,2.8,9.648,9.648,0,0,0,1.89,2.315A14.963,14.963,0,0,0,74.907,133.986Zm-9.074,5.861h3.056V145.9H81.806v2.615H65.833Zm12.287,1.229V120.5h3.025v20.573Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M92.012,135.94l-7.182.031v-2.425h5.229q1.575,0,3.45-.062t3.67-.159q1.827-.095,3.45-.22t2.756-.283v2.362q-1.323.189-3.575.379t-4.679.283v3.969H92.012Zm1.638-15.373a7.027,7.027,0,0,1,2.568.472,6.951,6.951,0,0,1,2.127,1.292,6.47,6.47,0,0,1,1.417,1.921,5.477,5.477,0,0,1,0,4.726,6.424,6.424,0,0,1-1.417,1.922,6.95,6.95,0,0,1-2.127,1.292,7.027,7.027,0,0,1-2.568.471,7.118,7.118,0,0,1-2.6-.471,6.528,6.528,0,0,1-2.094-1.292,5.758,5.758,0,0,1-1.418-1.922,5.791,5.791,0,0,1,0-4.726,5.794,5.794,0,0,1,1.418-1.921,6.528,6.528,0,0,1,2.094-1.292A7.119,7.119,0,0,1,93.65,120.567Zm0,9.609a3.553,3.553,0,0,0,2.536-1.041,3.518,3.518,0,0,0,0-5.088,3.574,3.574,0,0,0-5.071,0,3.518,3.518,0,0,0,0,5.088A3.554,3.554,0,0,0,93.65,130.176Zm-1.606,11.119H95.1v4.6h12.884v2.615H92.044Zm12.727-1.922H98.848V136.98h5.923V120.536H107.8V141.9h-3.025Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M130.005,136.6v2.458q-.945.157-2.393.282c-.967.085-2.007.157-3.12.222-1.133.082-2.284.147-3.449.188s-2.252.063-3.261.063l-5.388.032v-2.521h4.286q1.573,0,3.449-.063t3.67-.157q1.827-.095,3.45-.22T130.005,136.6Zm-15.814-8.759a6.554,6.554,0,0,1,.519-2.6,7.034,7.034,0,0,1,1.4-2.127,6.956,6.956,0,0,1,2.125-1.449,6.535,6.535,0,0,1,5.184,0,6.529,6.529,0,0,1,2.111,1.449,6.98,6.98,0,0,1,1.448,2.127,6.348,6.348,0,0,1,.537,2.6,6.426,6.426,0,0,1-.537,2.632,6.951,6.951,0,0,1-1.448,2.126,6.717,6.717,0,0,1-7.295,1.4,6.342,6.342,0,0,1-3.528-3.528A6.635,6.635,0,0,1,114.191,127.843Zm10.364,0a4.141,4.141,0,0,0-1.1-2.881,3.427,3.427,0,0,0-2.616-1.214,3.356,3.356,0,0,0-2.614,1.214,4.2,4.2,0,0,0-1.072,2.881,4.136,4.136,0,0,0,1.072,2.884,3.394,3.394,0,0,0,2.614,1.18,3.466,3.466,0,0,0,2.616-1.18A4.075,4.075,0,0,0,124.555,127.843Zm6.805,16.76V120.536h3.056V144.6Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9",
    "data-name": "\\uD328\\uC2A4 9",
    d: "M146.323,135.877h-3.307v-8.442h12.475v-3.151H143.016v-2.521h15.719v8.1H146.229v3.465h13.1v2.552h-3.4v4h7.876v2.552h-25.8v-2.552h8.316Zm2.866,0v4h3.876v-4Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10",
    "data-name": "\\uD328\\uC2A4 10",
    d: "M170.108,124.789h-3.969v-2.678h10.8v2.678H173.1v1.26a18.147,18.147,0,0,0,.252,3.134,9.991,9.991,0,0,0,.85,2.662,11.082,11.082,0,0,0,1.512,2.378,19.036,19.036,0,0,0,2.4,2.379l-1.545,1.827a8.266,8.266,0,0,1-1.449-1.149,18.2,18.2,0,0,1-1.386-1.528,14.36,14.36,0,0,1-1.2-1.575,9.074,9.074,0,0,1-.82-1.514,9.075,9.075,0,0,1-.8,1.545,17.864,17.864,0,0,1-1.183,1.638,19.767,19.767,0,0,1-1.5,1.639,16.047,16.047,0,0,1-1.559,1.354l-1.86-1.8a17.385,17.385,0,0,0,2.647-2.647,13.01,13.01,0,0,0,1.67-2.74,12.355,12.355,0,0,0,.74-2.584,17.419,17.419,0,0,0,.236-2.96Zm15.184,3.4v-7.624h2.962v24.256h-2.962V131.089H182.08V144.1h-2.837V121.007h2.837v7.184Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11",
    "data-name": "\\uD328\\uC2A4 11",
    d: "M208.164,132.663v2.458a20.442,20.442,0,0,1-2.174.331q-1.325.141-2.772.237-1.419.095-2.774.142t-2.205.046l-5.134.031V121.763h11.782v2.647H196.16v8.946l2.584-.031q.945,0,2.142-.047c.8-.031,1.606-.067,2.426-.11q1.259-.095,2.5-.205T208.164,132.663Zm-10.082,7.184h3.056V145.9h12.6v2.615H198.082ZM213.3,128.379h4v2.647h-4v10.05h-3.024V120.5H213.3Z",
    fill: "#767676"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3",
    "data-name": "\\uADF8\\uB8F9 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12",
    "data-name": "\\uD328\\uC2A4 12",
    d: "M36.674,128.967c-.274.045-.628.087-1.063.124s-.9.074-1.4.108-1.028.054-1.548.076-1,.035-1.439.035l-2.358.013v-1.274H30.74c.457,0,.964-.008,1.521-.028s1.1-.041,1.645-.068,1.064-.074,1.549-.11.89-.077,1.219-.122Zm-6.825-6.126a3,3,0,0,1,.644-.959,3.078,3.078,0,0,1,2.179-.892,3.005,3.005,0,0,1,1.192.241,3.059,3.059,0,0,1,.974.651,2.994,2.994,0,0,1,.664.959,2.979,2.979,0,0,1,0,2.343,2.992,2.992,0,0,1-.664.961,3.159,3.159,0,0,1-2.166.863,3.105,3.105,0,0,1-1.206-.235,3.058,3.058,0,0,1-.973-.628,3,3,0,0,1-.644-.961,3.061,3.061,0,0,1,0-2.343Zm3.872-.041a1.359,1.359,0,0,0-1.049-.507,1.329,1.329,0,0,0-1.048.507,1.8,1.8,0,0,0-.432,1.207,1.76,1.76,0,0,0,.432,1.2,1.34,1.34,0,0,0,1.048.494,1.37,1.37,0,0,0,1.049-.494,1.728,1.728,0,0,0,.445-1.2A1.767,1.767,0,0,0,33.721,122.8Zm3.391-2.069h1.6v10.662h-1.6Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_13",
    "data-name": "\\uD328\\uC2A4 13",
    d: "M42.938,127.6v-3.865h5.426v-1.179H42.938v-1.288H50.05v3.714H44.609v1.316h5.7v1.3h-1.48v1.549h3.425v1.3h-11.5v-1.3h3.6V127.6Zm2.946,1.549h1.425V127.6H45.884Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_14",
    "data-name": "\\uD328\\uC2A4 14",
    d: "M30.794,136.574v1.684h2.331v-1.684h1.589v5.865H29.2v-5.865Zm0,4.577h2.331v-1.618H30.794Zm2.632,2.275V144.7h3.55v-1.273h1.6v5.085H31.823v-5.085Zm0,2.534v1.262h3.55V145.96Zm3.686-9.826H38.7v6.8h-1.59V140.15H35.167v-1.33h1.945Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_15",
    "data-name": "\\uD328\\uC2A4 15",
    d: "M41.484,138.444a3.152,3.152,0,0,1,.672-1.007,3.312,3.312,0,0,1,1.014-.693,3.062,3.062,0,0,1,1.247-.254,3.028,3.028,0,0,1,1.234.254,3.288,3.288,0,0,1,1.014.693,3.235,3.235,0,0,1,.678,1.007,3.077,3.077,0,0,1,.254,1.24,3.114,3.114,0,0,1-.254,1.255,3.2,3.2,0,0,1-1.692,1.693,3.124,3.124,0,0,1-1.234.245,3.16,3.16,0,0,1-1.247-.245,3.256,3.256,0,0,1-1.014-.686,3.163,3.163,0,0,1-.672-1.007,3.214,3.214,0,0,1-.246-1.255A3.176,3.176,0,0,1,41.484,138.444Zm4.036-.042a1.425,1.425,0,0,0-2.213,0,2.053,2.053,0,0,0,0,2.57,1.434,1.434,0,0,0,2.213,0,2.025,2.025,0,0,0,0-2.57Zm.186,6.147v2.631h5.619v1.331H44.1v-3.962Zm3.741-8.415h1.59v9.032h-1.59Z",
    fill: "#767676"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4",
    "data-name": "\\uADF8\\uB8F9 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16",
    "data-name": "\\uD328\\uC2A4 16",
    d: "M29.558,161.233a3.3,3.3,0,0,0,1.734.493c1,0,1.578-.526,1.578-1.288,0-.694-.4-1.107-1.422-1.488-1.23-.448-1.991-1.1-1.991-2.148a2.171,2.171,0,0,1,2.439-2.048,3.377,3.377,0,0,1,1.656.369l-.269.794a2.8,2.8,0,0,0-1.42-.357c-1.03,0-1.422.615-1.422,1.13,0,.705.459,1.051,1.5,1.455,1.275.491,1.914,1.107,1.914,2.214,0,1.165-.851,2.182-2.63,2.182a3.9,3.9,0,0,1-1.925-.491Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M36.166,154.877v3.155h3.648v-3.155H40.8v7.542h-.984v-3.536H36.166v3.536h-.985v-7.542Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_18",
    "data-name": "\\uD328\\uC2A4 18",
    d: "M43.454,154.877v7.542h-.985v-7.542Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    d: "M45.151,162.419v-7.542h1.074l2.407,3.815a21.217,21.217,0,0,1,1.342,2.452l.034-.012c-.09-1.007-.112-1.925-.112-3.1v-3.155h.918v7.542h-.985l-2.4-3.827a21.932,21.932,0,0,1-1.4-2.518l-.033.012c.055.951.067,1.857.067,3.111v3.222Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_20",
    "data-name": "\\uD328\\uC2A4 20",
    d: "M53.738,162.419l-1.914-7.542h1.03l.894,3.815c.225.94.426,1.881.561,2.607h.022c.123-.749.358-1.644.615-2.618l1.007-3.8h1.018l.918,3.827c.213.9.415,1.79.526,2.585h.023c.156-.828.369-1.667.6-2.608l1-3.8h1L58.9,162.419H57.878l-.951-3.929a22.739,22.739,0,0,1-.492-2.461h-.023a21.066,21.066,0,0,1-.582,2.461l-1.074,3.929Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_21",
    "data-name": "\\uD328\\uC2A4 21",
    d: "M68.409,158.57c0,2.583-1.578,3.971-3.5,3.971-2,0-3.39-1.555-3.39-3.837,0-2.395,1.477-3.962,3.491-3.962C67.077,154.742,68.409,156.32,68.409,158.57Zm-5.864.111c0,1.623.873,3.066,2.418,3.066s2.417-1.421,2.417-3.133c0-1.511-.784-3.078-2.406-3.078S62.545,157.037,62.545,158.681Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_22",
    "data-name": "\\uD328\\uC2A4 22",
    d: "M69.665,162.419v-7.542h1.074l2.407,3.815a21.067,21.067,0,0,1,1.342,2.452l.034-.012c-.089-1.007-.111-1.925-.111-3.1v-3.155h.917v7.542h-.985l-2.4-3.827a21.931,21.931,0,0,1-1.4-2.518l-.033.012c.055.951.067,1.857.067,3.111v3.222Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M86.1,159.1c-.056-1.051-.122-2.327-.122-3.254h-.023c-.268.872-.571,1.823-.951,2.865l-1.332,3.658h-.739L81.7,158.782c-.357-1.074-.648-2.036-.862-2.931h-.021c-.023.939-.08,2.193-.146,3.334l-.2,3.234h-.93l.526-7.542h1.242l1.287,3.648c.314.928.561,1.757.761,2.54h.023c.2-.761.47-1.588.806-2.54l1.342-3.648H86.77l.469,7.542h-.962Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_24",
    "data-name": "\\uD328\\uC2A4 24",
    d: "M92.625,158.883H89.7V161.6h3.267v.817H88.718v-7.542H92.8v.816H89.7v2.384h2.921Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_25",
    "data-name": "\\uD328\\uC2A4 25",
    d: "M94.23,154.989a12.562,12.562,0,0,1,2.07-.169,4.373,4.373,0,0,1,3.055.94,3.443,3.443,0,0,1,1.074,2.709,4.026,4.026,0,0,1-1.086,2.931A4.689,4.689,0,0,1,96,162.486a15.538,15.538,0,0,1-1.768-.09Zm.974,6.669a8.189,8.189,0,0,0,.984.045,2.9,2.9,0,0,0,3.212-3.2c.011-1.779-1-2.909-3.055-2.909a5.585,5.585,0,0,0-1.141.1Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_26",
    "data-name": "\\uD328\\uC2A4 26",
    d: "M102.648,154.877v7.542h-.985v-7.542Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27",
    "data-name": "\\uD328\\uC2A4 27",
    d: "M109.605,162.184a4.807,4.807,0,0,1-1.991.357,3.518,3.518,0,0,1-3.716-3.825,3.747,3.747,0,0,1,3.939-3.962,4.059,4.059,0,0,1,1.791.336l-.246.794a3.461,3.461,0,0,0-1.512-.315,2.806,2.806,0,0,0-2.943,3.112,2.735,2.735,0,0,0,2.888,3.033,3.918,3.918,0,0,0,1.6-.314Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_28",
    "data-name": "\\uD328\\uC2A4 28",
    d: "M112.094,160.047l-.784,2.372H110.3l2.573-7.542h1.165l2.574,7.542h-1.041l-.805-2.372Zm2.485-.761-.751-2.172c-.167-.492-.28-.939-.391-1.376h-.023c-.112.437-.223.907-.38,1.365l-.74,2.183Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_29",
    "data-name": "\\uD328\\uC2A4 29",
    d: "M117.7,154.877h.986V161.6h3.222v.817H117.7Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_30",
    "data-name": "\\uD328\\uC2A4 30",
    d: "M125.614,154.877h4.063v.816H126.6V158.2h2.842v.806H126.6v3.414h-.986Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_31",
    "data-name": "\\uD328\\uC2A4 31",
    d: "M137.517,158.57c0,2.583-1.578,3.971-3.5,3.971-2.005,0-3.391-1.555-3.391-3.837,0-2.395,1.478-3.962,3.49-3.962C136.185,154.742,137.517,156.32,137.517,158.57Zm-5.864.111c0,1.623.873,3.066,2.417,3.066s2.418-1.421,2.418-3.133c0-1.511-.784-3.078-2.407-3.078S131.653,157.037,131.653,158.681Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_32",
    "data-name": "\\uD328\\uC2A4 32",
    d: "M139.746,154.877v4.476c0,1.678.75,2.394,1.757,2.394,1.108,0,1.836-.737,1.836-2.394v-4.476h.984v4.409c0,2.316-1.221,3.255-2.853,3.255-1.545,0-2.709-.871-2.709-3.222v-4.442Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33",
    "data-name": "\\uD328\\uC2A4 33",
    d: "M146.006,162.419v-7.542h1.075l2.4,3.815a21.1,21.1,0,0,1,1.344,2.452l.032-.012c-.089-1.007-.11-1.925-.11-3.1v-3.155h.918v7.542h-.985l-2.4-3.827a21.755,21.755,0,0,1-1.4-2.518l-.036.012c.057.951.069,1.857.069,3.111v3.222Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34",
    "data-name": "\\uD328\\uC2A4 34",
    d: "M153.361,154.989a12.575,12.575,0,0,1,2.071-.169,4.369,4.369,0,0,1,3.054.94,3.439,3.439,0,0,1,1.074,2.709,4.029,4.029,0,0,1-1.084,2.931,4.694,4.694,0,0,1-3.347,1.086,15.551,15.551,0,0,1-1.768-.09Zm.974,6.669a8.2,8.2,0,0,0,.984.045,2.9,2.9,0,0,0,3.212-3.2c.012-1.779-1-2.909-3.054-2.909a5.6,5.6,0,0,0-1.142.1Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_35",
    "data-name": "\\uD328\\uC2A4 35",
    d: "M161.869,160.047l-.784,2.372h-1.007l2.573-7.542h1.165l2.574,7.542h-1.04l-.806-2.372Zm2.484-.761-.751-2.172c-.167-.492-.279-.939-.39-1.376h-.023c-.113.437-.223.907-.38,1.365l-.74,2.183Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36",
    "data-name": "\\uD328\\uC2A4 36",
    d: "M168.061,155.705h-2.293v-.828h5.584v.828h-2.3v6.714h-.987Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_37",
    "data-name": "\\uD328\\uC2A4 37",
    d: "M173.159,154.877v7.542h-.985v-7.542Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_38",
    "data-name": "\\uD328\\uC2A4 38",
    d: "M181.3,158.57c0,2.583-1.577,3.971-3.5,3.971-2,0-3.391-1.555-3.391-3.837,0-2.395,1.477-3.962,3.489-3.962C179.971,154.742,181.3,156.32,181.3,158.57Zm-5.864.111c0,1.623.874,3.066,2.417,3.066s2.418-1.421,2.418-3.133c0-1.511-.784-3.078-2.406-3.078S175.438,157.037,175.438,158.681Z",
    fill: "#a6a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_39",
    "data-name": "\\uD328\\uC2A4 39",
    d: "M182.558,162.419v-7.542h1.075l2.4,3.815a21.232,21.232,0,0,1,1.343,2.452l.033-.012c-.09-1.007-.111-1.925-.111-3.1v-3.155h.918v7.542h-.986l-2.4-3.827a21.77,21.77,0,0,1-1.4-2.518l-.034.012c.056.951.068,1.857.068,3.111v3.222Z",
    fill: "#a6a7a7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2647eeb928b882497559f37b1939abd5.svg";
export { ForwardRef as ReactComponent };